import { useQuery } from "@tanstack/react-query";
import {
  UserSearchParams,
  userSearch,
} from "common/api/citajteo/citajteo_user";
import { QUERY_KEYS } from "constant/react_query";

export const useUserSearch = (searchParams?: UserSearchParams) => {
  const { data: user } = useQuery(
    [QUERY_KEYS.CITAJTEO_USER_SEARCH, searchParams],
    async () => {
      const result = await userSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof user !== "undefined" && user !== "" ? user : null;
  return result;
};
